export default "__VITE_ASSET__BEK$D2qI__"